/**
 * メール配信先
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";

import { State } from "src/state/ducks";
import * as ShopActions from "src/state/ducks/shop/actions";
import StyleConfig from "src/constants/StyleConfig";
import { DefaultPageProps, HistoryProps } from "src/constants/Interface";

import { DefaultLayout } from "src/components/layouts/DefaultLayout";
import Heading from "src/components/atoms/typo/Heading";
import SpinnerModal from "src/components/organisms/loading/SpinnerModal";
import Button, { LinkButton } from "src/components/atoms/button/Button";

type OwnProps = {
  id: string;
};

type Props = DefaultPageProps &
  HistoryProps &
  OwnProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const MailList = ({
  mailSenders,
  onDelete,
}: {
  mailSenders: string[];
  onDelete: (address: string) => void;
}) => {
  return (
    <div>
      {mailSenders.map((_, idx) => {
        return (
          <List key={idx}>
            <div className="left">
              <p>{_}</p>
            </div>
            <div className="right">
              <Button
                isDisabled={false}
                clickEvent={() => {
                  onDelete(_);
                }}
                text={"削除"}
              />
            </div>
          </List>
        );
      })}
    </div>
  );
};

class ShopMailSenderPage extends Component<Props> {
  componentDidMount() {
    this.props.getShop(this.props.login_shop_id);
  }

  onDelete = (address: string) => {
    const { login_shop_id, updateMailSenders } = this.props;
    updateMailSenders(login_shop_id, "delete", address);
  };

  render() {
    const { isFetching } = this.props;
    const { shop } = this.props;
    let senders: string[] = [];
    if (shop.owners && shop.owners.mail_senders) {
      senders = shop.owners.mail_senders;
    }
    if (
      this.props.shop.id !== "" &&
      this.props.login_shop_id !== this.props.shop.id
    ) {
      return (
        <Redirect
          to={{
            pathname: "/error",
            state: { errCode: 403 },
          }}
        />
      );
    }
    return (
      <DefaultLayout {...this.props}>
        <Block>
          <SpinnerModal isLoading={isFetching} />
          <Heading text={"取り置き注文の通知を受け取るメールアドレス"} />
          {senders.length > 0 ? (
            <MailList mailSenders={senders} onDelete={this.onDelete} />
          ) : (
            <div>
              <p>メールアドレスが登録されていません</p>
            </div>
          )}
          <div className="button__wrapper">
            <LinkButton
              isDisabled={false}
              url={`/shop/${this.props.login_shop_id}/owners/mail_sender/create`}
              text="取り置き注文の通知を受け取るメールアドレスの新規登録"
            />
          </div>
        </Block>
      </DefaultLayout>
    );
  }
}

const Block = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
  .button__wrapper {
    margin-top: ${StyleConfig.HELPER.M20};
  }
`;

const List = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  margin: ${StyleConfig.HELPER.M8} auto;
  padding: ${StyleConfig.HELPER.M8};
`;

const mapStateToProps = (state: State) => ({
  shop: state.shop.currentShop.resource,
  isFetching: state.shop.currentShop.isFetching,
  validationErros: state.shop.currentShop.validationErrors,
  apiErrors: state.shop.currentShop.apiError,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getShop: (document_id: string) => dispatch(ShopActions.getShop(document_id)),
  updateMailSenders: (
    document_id: string,
    method: "add" | "delete",
    address: string
  ) =>
    dispatch(
      ShopActions.updateMailSenders({
        doc_id: document_id,
        method: method,
        address: address,
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShopMailSenderPage);
